/**
 * Resolve an image URL string for display in <img>.
 * - Absolute URLs (http/https/data) → returned as-is
 * - Relative URLs starting with "/" → prefixed with REACT_APP_BACKEND_URL
 * - Empty/falsy → null (caller decides fallback)
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export function resolveImageUrl(url) {
  if (!url || typeof url !== "string") return null;
  const trimmed = url.trim();
  if (!trimmed) return null;
  if (trimmed.startsWith("http://") || trimmed.startsWith("https://") || trimmed.startsWith("data:")) {
    return trimmed;
  }
  if (trimmed.startsWith("/")) {
    return `${BACKEND_URL}${trimmed}`;
  }
  return trimmed;
}
